import React from 'react';

import {
  InputContainer,
  InputLabel,
  InputSelectionBox,
  InputSelectedBox,
  InputSelectedRadio,
  CheckboxButton,
  CheckBoxSelectedIcon,
  FreecodeInputSelectionBox,
  FreecodeInputSelectedBox,
  FreecodeInputLabel,
  FilterInputLabel,
} from './styles';

export const Checkbox = ({
  checked,
  label,
  onChange,
  disabled = false,
  title,
  type = 'button',
  usePadding,
  justifyContent,
}) => {
  const click = (e) => !disabled && onChange && onChange(e);
  return (
    <InputContainer title={title} usePadding={usePadding} justifyContent={justifyContent}>
      <InputSelectionBox checked={checked} disabled={disabled} type={type} onClick={click}>
        <InputSelectedBox checked={checked} />
      </InputSelectionBox>
      <InputLabel disabled={disabled} onClick={click}>
        {label}
      </InputLabel>
    </InputContainer>
  );
};

export const CheckboxMark = ({ checked, onChange, disabled = false, type = 'button' }) => {
  const click = () => !disabled && onChange && onChange();
  return (
    <InputSelectionBox checked={checked} disabled={disabled} type={type} onClick={click}>
      <InputSelectedBox checked={checked} />
    </InputSelectionBox>
  );
};

export const RadioButton = ({ checked, label, onChange, disabled = false, canDeSelect = false, type = 'button' }) => {
  const click = () => (!checked || canDeSelect) && !disabled && onChange && onChange();
  return (
    <InputContainer>
      <InputSelectionBox radio checked={checked} disabled={disabled} type={type} onClick={click}>
        <InputSelectedRadio checked={checked} />
      </InputSelectionBox>
      <InputLabel disabled={disabled} onClick={click}>
        {label}
      </InputLabel>
    </InputContainer>
  );
};

export const RadioButtonMark = ({ checked, onChange, disabled = false, canDeSelect = false, type = 'button' }) => {
  const click = () => (!checked || canDeSelect) && !disabled && onChange && onChange();
  return (
    <InputSelectionBox radio checked={checked} disabled={disabled} type={type} onClick={click}>
      <InputSelectedRadio checked={checked} />
    </InputSelectionBox>
  );
};

export const FilterCheckbox = ({
  checked,
  label,
  onChange,
  disabled = false,
  title,
  type = 'button',
  isSignUpPage,
}) => {
  const click = (e) => !disabled && onChange && onChange(e);
  return (
    <InputContainer title={title}>
      <CheckboxButton checked={checked} disabled={disabled} type={type} onClick={click}>
        <CheckBoxSelectedIcon checked={checked} />
      </CheckboxButton>
      <FilterInputLabel disabled={disabled} isSignUpPage={isSignUpPage} onClick={click}>
        {label}
      </FilterInputLabel>
    </InputContainer>
  );
};

export const FreecodeCheckbox = ({
  checked,
  label,
  onChange,
  disabled = false,
  title,
  type = 'button',
  usePadding,
  isSignUpModal,
}) => {
  const click = (e) => !disabled && onChange && onChange(e);
  return (
    <InputContainer title={title} usePadding={usePadding}>
      <FreecodeInputSelectionBox checked={checked} disabled={disabled} type={type} onClick={click}>
        <FreecodeInputSelectedBox checked={checked} />
      </FreecodeInputSelectionBox>
      <FreecodeInputLabel disabled={disabled} isSignUpModal={isSignUpModal} onClick={click}>
        {label}
      </FreecodeInputLabel>
    </InputContainer>
  );
};
